"use client";

import { useEffect } from "react";
import HomeEvents from "./HomeEvents";
import { GetHomeEvents, GetHomePeople } from "../actions";
import { Card } from "~/components/v4/shadcn/Card";
import HomeMyCommunitiesV2 from "./HomeMyCommunitiesV2";
import { GetHomeUserCommunities } from "~/app/my-communities/actions";
import HomePeople from "./HomePeople";
import EventsHeader from "./headers/EventsHeader";
import {
    GetCommunitiesToHost,
    GetCurrentUserProfile,
} from "../../events/create/actions";
import { useHomePageRenderStore } from "~/state/store";
import CommunitiesHeader from "./headers/CommunitiesHeader";
import PeopleHeader from "./headers/PeopleHeader";
import RiverLoading from "~/components/themed/RiverLoading";
import { useRouter, useSearchParams } from "next/navigation";

type Props = {
    userId: string;
    user: GetCurrentUserProfile;
    communities: GetCommunitiesToHost;
    peopleData: GetHomePeople;
    initialEvents: GetHomeEvents;
    userCommunities: GetHomeUserCommunities;
};

const MainLoggedInHomeContent = ({
    userId,
    user,
    communities,
    peopleData,
    initialEvents,
    userCommunities,
}: Props) => {
    const { tab, setTab } = useHomePageRenderStore();
    const router = useRouter();
    const searchParams = useSearchParams();

    useEffect(() => {
        if (tab === "none") {
            setTab("events");
        }
    }, [tab, setTab]);

    useEffect(() => {
        if (searchParams?.get("createCommunity") === "true") {
            router.push("/beta/community/create");
        }
    }, [searchParams, router]);

    if (tab === "discover") {
        return (
            <div className="flex h-screen w-full flex-col items-center justify-center">
                <RiverLoading />
            </div>
        );
    }

    return (
        <Card className="flex h-full min-h-screen w-full flex-col gap-8 p-4">
            {tab === "events" && (
                <div className="flex w-full flex-col gap-8">
                    <EventsHeader
                        user={user}
                        communities={communities}
                        _followerCount={peopleData?.counts.followers}
                    />
                    <HomeEvents
                        initialEvents={initialEvents}
                        communities={communities}
                        user={user}
                    />
                </div>
            )}
            {tab === "communities" && (
                <div className="flex w-full flex-col gap-8">
                    <CommunitiesHeader />
                    <HomeMyCommunitiesV2 myCommunities={userCommunities} />
                </div>
            )}
            {tab === "people" && (
                <div className="flex w-full flex-col gap-8">
                    <PeopleHeader user={user} communities={communities} />
                    <HomePeople peopleData={peopleData} />
                </div>
            )}
        </Card>
    );
};

export default MainLoggedInHomeContent;
